import { render, staticRenderFns } from "./ti_list.vue?vue&type=template&id=31d3e933&"
import script from "./ti_list.vue?vue&type=script&lang=js&"
export * from "./ti_list.vue?vue&type=script&lang=js&"
import style0 from "./ti_list.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports